import React from "react";
import CustomDropdown from "../../../constants/CustomDropdown";
import CustomHeading from "../../../constants/CustomHeading";

const Co_Po_Maping = (props) => {
	// const [filter,setFilter]=useState({
	// 	curriculum:'Select Curriculum',
	// 	term:'Select Term',
	// 	course:'Select Course'
	// })
	// const handleChange=(event)=>{
	// 	setFilter(({...filter,[event.target.id]:event.target.value})) 
	// }
	return (
    	<div className='customContainer'>
      		<CustomHeading title="Mapping between Course Outcomes (COs) and Program Outcomes (POs) Course wise" />
      		<div className="row">
				<div className='col-md-4'>
					{/* <CustomDropdown 
					label='Curriculum :'
					data="sdfds"
					defaultOption={'Select Curriculum'}
					notDefaultOption
					id={'curriculum'}
					onChange={handleChange}
					/> */}
				</div>
      		</div>
    	</div>
  	);
};

// const mapActionWithProps = {
// 	getCurriculumData,
// 	getCourseCurriculumData,
// 	getTermsData,
// 	getManageTopicAndTloData,
// }

// const mapStateWithProps = (state) => (
// 	{
// 		curriculums:state.data.curriculums,
// 		course_curriculum:state.data.course_curriculum,
// 		terms:state.data.terms,
// 		topics:state.data.topics,
// 	}
// )


export default Co_Po_Maping;
